
import { computed, defineComponent, ref } from 'vue';
import AppLazyImage from '@/components/UI/AppLazyImage.vue';
import AppPdfViewer from '@/components/AppPdfViewer.vue';
import AppVideoPlayer from '@/components/AppVideoPlayer.vue';
import { MEDIA_TYPES, PHOTO_VIEW_TYPE } from '@/types/enums';
import { IMedia } from '@/types/interfaces';
import convertPdfUrlToBlob from '@/helpers/pdfUrlToBlob';
import AppPDFViewerV2 from '@/components/AppPDFViewerV2.vue';
import NativeService from '@/services/NativeService';
import { useMainStore } from '@/store/mainStore';

export default defineComponent({
  components: {
    AppLazyImage,
    AppPdfViewer,
    AppVideoPlayer,
    AppPDFViewerV2,
  },
  props: {
    media: { type: Object as () => IMedia, required: true },
    pauseVideo: { type: Boolean, required: true },
  },
  emits: ['ifVideoPaused'],
  setup(props) {
    const mainStore = useMainStore();
    const baseURL = computed(() => process.env.VUE_APP_MEDIA_URL);
    const isPDF = computed(() => props.media.name?.includes('.pdf'));

    const pdfToOpen = ref<undefined | string>(undefined);

    const pdfLoading = ref(false);

    async function handlePdfOpen() {
      pdfLoading.value = true;
      const fileUrl = computed(() => (process.env.VUE_APP_MEDIA_URL || '') + props.media.fileUrl);

      if (isPDF.value && mainStore.isMobile) {
        NativeService.getPdfUrl(fileUrl.value);
        pdfLoading.value = false;
        return;
      }

      try {
        pdfToOpen.value = await convertPdfUrlToBlob(props.media.fileUrl, props.media.name);
      } catch (e) {
        pdfLoading.value = false;
      } finally {
        pdfLoading.value = false;
      }
    }

    return {
      baseURL,
      MEDIA_TYPES,
      PHOTO_VIEW_TYPE,
      isPDF,
      pdfLoading,

      pdfToOpen,
      handlePdfOpen,
    };
  },
});
